// Copyright (c) 2016 Deere & Company

import './dealer-search-result.scss';
import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';
import {buildCityStateZip} from '../../shared/services/product';

function handleDealerSelectClick() {

    this.onDealerSelectClick(this.dealer);

}

const DealerSearchResult = props =>
    <section className='dealer-search-result'>
        <div className='dealer-search-details'>
            <div className='dealer-name'>
                {props.dealer.industryIndicator && props.dealer.industryIndicator.length ? `${props.dealer.name}, ${props.dealer.account} (${props.dealer.industryIndicator})` : `${props.dealer.name}, ${props.dealer.account}`}
            </div>
            <div className='dealer-address'>
                {`${props.dealer.location.address1}, ${buildCityStateZip(props.dealer.location)}`}
            </div>
            <div className='dealer-email-phone'>
                {props.dealer.email.length ? `${props.dealer.email}, ${props.dealer.phone}` : props.dealer.phone}
            </div>
        </div>
        <button
            className='button-primary'
            onClick={props::handleDealerSelectClick}
        >
            <FormattedMessage id='SELECT'/>
        </button>
    </section>;

DealerSearchResult.displayName = 'DealerSearchResult';
DealerSearchResult.propTypes = {
    dealer: PropTypes.instanceOf(Dealer).isRequired,
    onDealerSelectClick: PropTypes.func.isRequired
};

export default DealerSearchResult;



// WEBPACK FOOTER //
// ./src/product/dealer-search/components/dealer-search-result.js